module.exports = __webpack_public_path__ + "4e953e76bf9b4e9aa31b1022da91615b.fbx";